/** Tiny haptic helpers — gated by user setting. */
export type HapticKind = 'tap' | 'success' | 'error' | 'select';

const PATTERNS: Record<HapticKind, number | number[]> = {
  tap: 10,
  select: 6,
  success: [12, 40, 12],
  error: [30, 50, 30, 50, 30],
};

export function haptic(kind: HapticKind, enabled = true) {
  if (!enabled) return;
  try {
    if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
      navigator.vibrate(PATTERNS[kind]);
    }
  } catch { /* ignore */ }
}
